import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  Flex,
  Button,
  Text,
  Box,
  Spinner,
} from '@chakra-ui/react';

const DeleteAdminModal = ({ isOpen, onClose, admin, onConfirm, isLoading }) => {
  const adminName = `${admin?.first_name || ''} ${admin?.surname || ''}`.trim() || 'this employee';

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        minH={'200px'}
        maxW={'400px'}
        borderRadius={16}
        padding={4}
        gap={4}
      >
        <ModalBody display={'flex'} flexDirection={'column'} gap={4}>
          <Text
            fontFamily={'PlusJakartaSansSemiBold'}
            fontSize={'24px'}
            lineHeight={'32px'}
            color={'#000000'}
          >
            Delete Employee
          </Text>
          <Box height="1px" width="100%" bg="#8A8F9333" mx="auto" />
          <Text
            fontFamily={'PlusJakartaSansRegular'}
            fontSize={'16px'}
            color={'#666666'}
          >
            Are you sure you want to delete <strong>{adminName}</strong>? This action cannot be undone.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Flex w={'100%'} justify={'flex-end'} gap={4}>
            <Button
              bg={'white'}
              border={'1px solid #000000'}
              color="#000000"
              borderRadius={8}
              paddingInline={16}
              textTransform={'uppercase'}
              onClick={onClose}
              isDisabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              isDisabled={isLoading}
              bg={'#E53E3E'}
              color="#FFFFFF"
              borderRadius={8}
              paddingInline={16}
              textTransform={'uppercase'}
              _hover={{ bg: '#C53030' }}
            >
              {isLoading ? <Spinner size="sm" /> : 'Delete'}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteAdminModal;
